<template>
    <div :content="logsCount"  v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
    {{data.otherReasonLogsCount }}
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {},
        }
    },
    computed: {
        logsCount() {
            var result = "";
            result += this.$t('CrossReadingLogs') + `: ${this.data.crossReadingLogsCount}<br\>` + this.$t('OtherTagInAntennaLogs') + `: ${this.data.otherTagInAntennaLogsCount}`
            return result
        }
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Settings/LogReasonTooltip.vue